import { useState } from "react";
import StartVotingPopUp from "../../../components/StartVotingPopUp.jsx";

function PeriodBanner({ isVotingActive, isAdmin, votingDeadline, suggestions, endVotingPeriod, extendVotingPeriod}) {
  const daysLeft = (new Date(votingDeadline) - new Date()) / (1000 * 60 * 60 * 24);
  const [showExtendPopup, setShowExtendPopup] = useState(false);

  return (
    <div>
      {isVotingActive && (
        <div className="bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-xl p-6 shadow-lg">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <div>
                <h3 className="mb-1 text-center">Voting Period Active</h3>
                <p>Members can suggest books and vote until {votingDeadline}</p>
              </div>
            </div>
            {isAdmin && (
              <button
                className="px-4 py-2 bg-white text-green-600 !rounded-full font-semibold hover:bg-green-50 transition-colors"
                onClick={()=>endVotingPeriod()}
              >
                End Voting Period Early
              </button>
              )}
            <div className="text-center bg-white/20 rounded-lg px-6 py-3">
              <div className="text-3xl mb-1">{Math.ceil(daysLeft)}</div>
              <div className="text-sm">days left</div>
            </div>
          </div>
        </div>
      )}

      {!isVotingActive && suggestions > 0 && (
        <div className="bg-gradient-to-r from-amber-500 to-orange-600 text-white rounded-xl p-6 shadow-lg flex items-center justify-between">
          <div className="text-center">
            <h3 className="mb-1">Voting Period Ended</h3>
            <p>
              The voting deadline has passed.
              {isAdmin
                ? " Please select the winning book for the club."
                : " Please wait for the admin to select the winning book."}
            </p>
          </div>
          {isAdmin && (
              <button
                className="px-4 py-2 bg-white text-green-600 !rounded-full font-semibold hover:bg-green-50 transition-colors"
                onClick={()=>setShowExtendPopup(true)}
              >
                Extend Voting Period
              </button>
              )}
        </div>
      )}
      <StartVotingPopUp
              show={showExtendPopup}
              setShow={setShowExtendPopup}
              onStartVotingPeriod={(date) => extendVotingPeriod(date)}
            />
    </div>
  );
}

export default PeriodBanner;